// Messages for operator/settings/Webhooks (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.webhooks.head': 'Webhooks — Operator',
  'operator.webhooks.title': 'Webhooks',
  'operator.webhooks.desc':
    'Push platform events into your own back-office systems, Teams, or Slack. Deliveries are HMAC-signed and retried.',
  'operator.webhooks.new_endpoint': 'New endpoint',
  'operator.webhooks.edit_endpoint': 'Edit endpoint',
  'operator.webhooks.create': 'Create endpoint',
  'operator.webhooks.save': 'Save changes',
  'operator.webhooks.edit': 'Edit',
  'operator.webhooks.delete': 'Delete',
  'operator.webhooks.confirm_delete':
    'Delete this webhook endpoint? Its delivery history will be removed too.',
  'operator.webhooks.status_label': 'Status',
  'operator.webhooks.status_hint': 'Uncheck to pause deliveries to this endpoint.',
  'operator.webhooks.status_active': 'Active',
  'operator.webhooks.cancel': 'Cancel',
  'operator.webhooks.secret_title': 'Signing secret',
  'operator.webhooks.secret_notice_before':
    "Copy this signing secret now — it won't be shown again. Verify the",
  'operator.webhooks.secret_notice_after': 'header on every delivery with it.',
  'operator.webhooks.copy': 'Copy',
  'operator.webhooks.copied': 'Copied',
  'operator.webhooks.endpoint_url': 'Endpoint URL',
  'operator.webhooks.url_error': 'URL {error}',
  'operator.webhooks.url_hint':
    "Where we'll POST each subscribed event. Must be a public https URL.",
  'operator.webhooks.format_label': 'Payload format',
  'operator.webhooks.format_sub': 'How the body is shaped for the receiver.',
  'operator.webhooks.events_selected': '{count} selected',
  'operator.webhooks.select_all': 'Select all',
  'operator.webhooks.clear_all': 'Clear all',
  'operator.webhooks.format.json': 'JSON (generic)',
  'operator.webhooks.format.teams': 'Microsoft Teams',
  'operator.webhooks.format.slack': 'Slack',
  'operator.webhooks.format_hint.json': 'Signed event envelope for your back-office integration.',
  'operator.webhooks.format_hint.teams': 'Adaptive Card for a Teams / Power Automate flow.',
  'operator.webhooks.format_hint.slack': 'Message for a Slack incoming webhook.',
  'operator.webhooks.events': 'Events',
  'operator.webhooks.events_hint': 'Subscribe to one or more events from across the platform.',
  'operator.webhooks.add_endpoint': 'Add endpoint',
  'operator.webhooks.consecutive_failures': '{count} consecutive failures',
  'operator.webhooks.secret': 'secret',
  'operator.webhooks.disable': 'Disable',
  'operator.webhooks.test': 'Test',
  'operator.webhooks.testing': 'Testing…',
  'operator.webhooks.status.active': 'Active',
  'operator.webhooks.status.disabled': 'Disabled',
  'operator.webhooks.events_count': '{count} events',
  'operator.webhooks.no_events': 'No events subscribed',
  'operator.webhooks.deliveries': 'Recent deliveries',
  'operator.webhooks.no_deliveries': 'No deliveries yet.',
  'operator.webhooks.col.event': 'Event',
  'operator.webhooks.col.state': 'State',
  'operator.webhooks.col.status': 'Status',
  'operator.webhooks.col.attempts': 'Attempts',
  'operator.webhooks.col.when': 'When',
  'operator.webhooks.state.pending': 'Pending',
  'operator.webhooks.state.delivered': 'Delivered',
  'operator.webhooks.state.failed': 'Failed',
  'operator.webhooks.replay': 'Replay',
  'operator.webhooks.empty': 'No webhook endpoints yet.',
  'operator.webhooks.empty_hint':
    'Register an endpoint to start receiving signed platform-event deliveries.',
}

export const zhTW = {
  'operator.webhooks.head': 'Webhook — 操作員',
  'operator.webhooks.title': 'Webhook',
  'operator.webhooks.desc':
    '將平台事件推送至您自己的後台系統、Teams 或 Slack。傳送內容以 HMAC 簽署並會重試。',
  'operator.webhooks.new_endpoint': '新增端點',
  'operator.webhooks.edit_endpoint': '編輯端點',
  'operator.webhooks.create': '建立端點',
  'operator.webhooks.save': '儲存變更',
  'operator.webhooks.edit': '編輯',
  'operator.webhooks.delete': '刪除',
  'operator.webhooks.confirm_delete': '要刪除此 Webhook 端點嗎？其傳送紀錄也會一併移除。',
  'operator.webhooks.status_label': '狀態',
  'operator.webhooks.status_hint': '取消勾選即可暫停對此端點的傳送。',
  'operator.webhooks.status_active': '啟用中',
  'operator.webhooks.cancel': '取消',
  'operator.webhooks.secret_title': '簽署密鑰',
  'operator.webhooks.secret_notice_before':
    '請立即複製此簽署密鑰 — 之後將不會再顯示。請以它驗證每次傳送的',
  'operator.webhooks.secret_notice_after': '標頭。',
  'operator.webhooks.copy': '複製',
  'operator.webhooks.copied': '已複製',
  'operator.webhooks.endpoint_url': '端點 URL',
  'operator.webhooks.url_error': 'URL{error}',
  'operator.webhooks.url_hint': '我們會將每個已訂閱的事件 POST 至此處。必須為公開的 https URL。',
  'operator.webhooks.format_label': '內容格式',
  'operator.webhooks.format_sub': '依接收方需求調整內容格式。',
  'operator.webhooks.events_selected': '已選 {count} 個',
  'operator.webhooks.select_all': '全選',
  'operator.webhooks.clear_all': '全部清除',
  'operator.webhooks.format.json': 'JSON（通用）',
  'operator.webhooks.format.teams': 'Microsoft Teams',
  'operator.webhooks.format.slack': 'Slack',
  'operator.webhooks.format_hint.json': '供您後台整合使用的已簽署事件封包。',
  'operator.webhooks.format_hint.teams': '供 Teams／Power Automate 流程使用的 Adaptive Card。',
  'operator.webhooks.format_hint.slack': '供 Slack incoming webhook 使用的訊息。',
  'operator.webhooks.events': '事件',
  'operator.webhooks.events_hint': '訂閱平台上一個或多個事件。',
  'operator.webhooks.add_endpoint': '新增端點',
  'operator.webhooks.consecutive_failures': '連續 {count} 次失敗',
  'operator.webhooks.secret': '密鑰',
  'operator.webhooks.disable': '停用',
  'operator.webhooks.test': '測試',
  'operator.webhooks.testing': '測試中…',
  'operator.webhooks.status.active': '啟用中',
  'operator.webhooks.status.disabled': '已停用',
  'operator.webhooks.events_count': '{count} 個事件',
  'operator.webhooks.no_events': '未訂閱任何事件',
  'operator.webhooks.deliveries': '最近傳送',
  'operator.webhooks.no_deliveries': '尚無傳送紀錄。',
  'operator.webhooks.col.event': '事件',
  'operator.webhooks.col.state': '狀態',
  'operator.webhooks.col.status': '回應碼',
  'operator.webhooks.col.attempts': '嘗試次數',
  'operator.webhooks.col.when': '時間',
  'operator.webhooks.state.pending': '處理中',
  'operator.webhooks.state.delivered': '已送達',
  'operator.webhooks.state.failed': '失敗',
  'operator.webhooks.replay': '重送',
  'operator.webhooks.empty': '尚無 Webhook 端點。',
  'operator.webhooks.empty_hint': '註冊端點以開始接收已簽署的平台事件傳送。',
}
